<template>
  <div :id="$route.name">
    <card back>
      <template v-slot:header>
        <h3>گزارش سررسید قراردادها</h3>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-3 col-12">
            <date-picker color="dimgray" v-model="DataAxios.StartDate" clearable :editable="true" placeholder=" از تاریخ "></date-picker>
          </div>
          <div class="col-md-3 col-12">
            <date-picker color="dimgray" v-model="DataAxios.EndDate" clearable :editable="true" placeholder=" تا تاریخ "></date-picker>
          </div>
          <div class="col-md-3 col-12">
            <span class="form-control p-1 text-center">
              <div class="custom-control custom-switch">
                <input type="checkbox" class="custom-control-input InputText" id="NeedSubmit" v-model="DataAxios.NeedSubmit" />
                <label class="custom-control-label" for="NeedSubmit"> محصولاتی نیاز به تمدید</label>
              </div>
            </span>
          </div>
          <div class="col-md-3 col-12" dir="ltr">
            <b-form-group v-slot="{ ariaDescribedby }">
              <b-form-radio-group id="btn-radios-2" v-model="selected" :options="options" :aria-describedby="ariaDescribedby" button-variant="outline-info" size="sm" name="radio-btn-outline" buttons @change="ChangRadio(selected)"> </b-form-radio-group>
            </b-form-group>
          </div>
          <div class="col-md-3 col-12">
            <button class="btn btn-success float-left w-100 text-center" dir="ltr" @click.prevent="Search()">جستجو <i class="fas fa-search mx-2"></i></button>
          </div>
        </div>

        <div class="row p-4">
          <BnpGrid v-if="$store.state.renderComponentGrid" :hasRowNum="true" :propsColumn="Column" :propsRows="Rows" :Sortable="true" :pagenum="50" :action="true" :IsReport="true" :HeaderReport="'گزارش سررسید قراردادها'" :ListCommaReport="['Amount', 'TotallAmount']">
            <template slot="action-slot" slot-scope="props">
              <a href="javascript:;" class="mr-2 badge" @click="OnAgain(props.props)" data-title="تمدید ">
                <h5><span class="fad fa-box-check text-secondary hover-warning"></span></h5>
              </a>
              <!-- <a href="javascript:;" class="mr-2 badge"  @click="OnDetailProduct(props.props)" data-title="محصولات">
                                    <h5><span class="fad fa-info-circle hover-info"></span></h5>
                                </a> -->
              <!-- <a href="javascript:;" class="mr-2 badge" @click="OnRate(props.props)" data-title="نرخ گذاری محصولات جهت تمدید">
                                    <h5><span class="fad fa-info"></span></h5>
                                </a> -->
              <a v-if="$IsAccess('btnSaveRate')" href="javascript:;" class="mr-2 badge" @click="SaveRate(props.props)" data-title="ثبت نرخ">
                <h5><span class="fad fa-save"></span></h5>
              </a>
            </template>
            <template slot="TotallAmount" slot-scope="props">
              <span>{{ $Comma3ragham(props.props.TotallAmount) }}</span>
            </template>
            <template slot="Amount" slot-scope="props">
              <span>{{ $Comma3ragham(props.props.Amount) }}</span>
            </template>
            <template slot="Rate" slot-scope="props">
              <span>{{ $Comma3ragham(props.props.Rate) }}</span>
            </template>
            <template slot="Rate" slot-scope="props">
              <input dir="ltr" type="text" @keypress="$ValidNumber($event, 15)" @keyup="props.props.Rate = $PutCommatoInput_New($event);" class="form-control InputText 3ragham required" id="txtRate" v-model="props.props.Rate" tabindex="1" :disabled="$IsAccess('btnSaveRate') == true ? false : true" />
            </template>props.props.TblCustomerId
            <template slot="CustomerName" slot-scope="props">
              <a href="javascript:;" @click="$FindeCustomerById('DetailCustomer',props.props.TblCustomerId,false,$event)" 
                                     @click.middle="$FindeCustomerById('DetailCustomer',props.props.TblCustomerId,false,$event)"  
                                     style="white-space: nowrap; cursor: pointer !important" data-toggle="tooltip" data-placement="top" 
                                     :data-title="props.props.CustomerName">
                                      {{ props.props.CustomerName.slice(0, 30) + (props.props.CustomerName.length > 30 ? '...' : '') }}       
              </a>
            </template>
          </BnpGrid>
        </div>
      </template>
    </card>

    <!-- <b-modal size="xl" centered id="modal-DetailCustomerProduct">
        <template #modal-header="{ close }">
            <b-button size="sm" variant="outline-danger" @click="close()">
            <span aria-hidden="true">&times;</span>
            </b-button>
            <h5>جزئیات قرارداد</h5>
        </template>

        <template #default>
            <div dir="rtl">
            
            <BnpGrid v-if="$store.state.renderComponentGridModal" :hasRowNum="true" :propsColumn="ColumnDtail" :propsRows="RowsDetail" :action="true">
                <template slot="action-slot" slot-scope="props">
                    <a href="javascript:;" class="mr-2 badge" @click="SaveRate(props.props)" data-title="ثبت نرخ">
                        <h5><span class="fad fa-save"></span></h5>
                    </a>
                </template>
                <template slot="TotallAmount" slot-scope="props">
                    <span>{{ $Comma3ragham(props.props.TotallAmount) }}</span>
                </template>
                <template slot="Amount" slot-scope="props">
                    <span>{{ $Comma3ragham(props.props.Amount) }}</span>
                </template>
                <template slot="Rate" slot-scope="props">
                </template>
                </BnpGrid>
            </div>
        </template>
        <template #modal-footer="{ cancel }">
            <b-button id="CancelCopy" size="sm" variant="danger" @click="cancel()"> بستن </b-button>
        </template>
        </b-modal> -->
  </div>
</template>
<script>
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
import BnpGrid from '../../../components/BnpGrid/BnpGrid.vue'
import Card from '../../../components/Card/Card.vue'
export default {
  components: { Card, datePicker: VuePersianDatetimePicker, BnpGrid },
  data() {
    return {
      RedioSelect: 1,
      selected: 'New',
      options: [
        { text: 'جدید', value: 'New' },
        { text: 'همه', value: 'All' },
      ],
      DataAxios: {
        NeedSubmit: true,
        EndDate: '',
        StartDate: '',
        RedioSelect: 1,
      },
      Rows: [],
      RowsDetail: [],
      Column: [
        { name: 'Id', label: 'شماره قرارداد', visibility: true },
        { name: 'CustomerCode', label: 'کد مشتری', visibility: true },
        { name: 'CustomerName', label: 'نام مشتری', visibility: true },
        { name: 'Amount', label: 'مبلغ ', visibility: true },
        { name: 'TotallAmount', label: 'مبلغ کل ', visibility: true },
        { name: 'ContractEndDate', label: 'تاریخ پایان', visibility: true },
        { name: 'Name', label: 'محصول', visibility: true },
        { name: 'Rate', label: 'نرخ تمدید', visibility: true },
      ],
      // ColumnDtail: [{ name: 'Id', label: 'شماره قرارداد', visibility: true },
      // { name: 'Name', label: 'محصول', visibility: true },
      // { name: 'Amount', label: 'مبلغ محصول', visibility: true },
      // { name: 'Discount', label: 'تخفیف', visibility: true },
      // { name: 'TotallAmount', label: 'مبلغ کل محصول', visibility: true },
      // { name: 'Rate', label: 'نرخ تمدید', visibility: true },
      // ],
    }
  },
  methods: {
    testLink(p){
     
      const routeData = this.$router.resolve({name: 'DetailCustomer'});
      this.$store.dispatch("setCustomerId", p);
      window.open(routeData.href, '_blank');
    },
    ChangRadio(data) {
      this.DataAxios.RedioSelect = data == 'New' ? 1 : 0
      this.Search()
    },
    SaveRate(row) {
      if (row.Rate != null) {
        var DataAxios_update = {
          ArryfildValue: { ProductId: row.CpId, Rate: row.Rate },
          Method: 'put',
          Action: 'CustomerProduct/b_Update',
          Token: this.$session.get('Token'),
          From: 'Body',
        }
        this.$PutData_Body(DataAxios_update).then((data) => {
          if (data.status == 'Ok') {
            this.$toasted.success('نرخ تمدید با موفقیت ثبت شد', {
              action: {
                text: 'بستن',
                onClick: (e, toastObject) => {
                  toastObject.goAway(0)
                },
              },
            })
            this.Search()
            this.$store.state.renderComponentGrid = false
            this.$nextTick(() => {
              this.$store.state.renderComponentGrid = true
            })
          }
        })
      } else {
        this.$toasted.error('مقدار نرخ تمدید خالی است!', {
          action: {
            text: 'بستن',
            onClick: (e, toastObject) => {
              toastObject.goAway(0)
            },
          },
        })
      }
    },
    // OnRate(row){
    //     let DataAxios_CustomerProduct = {
    //         ArryfildValue: {ContractId:row.Id},
    //         Method: 'post',
    //         Action: 'ContractReminderReport/Get_DetailContract',
    //         Token: this.$session.get('Token'),
    //     }
    //     this.$PostData(DataAxios_CustomerProduct)
    //         .then((data) => {
    //             this.RowsDetail=data
    //     }).finally(()=>{
    //         this.$bvModal.show('modal-DetailCustomerProduct')
    //     this.$store.state.renderComponentGridModal = false
    //     this.$nextTick(() => {
    //         this.$store.state.renderComponentGridModal = true
    //     });
    //     })

    // },
    Search() {
      this.$store.state.FilterContractReminderReport=this.DataAxios
      let DataAxios_Data = {
        ArryfildValue: this.DataAxios,
        Method: 'post',
        Action: 'ContractReminderReport',
        Token: this.$session.get('Token'),
      }
      this.$PostData(DataAxios_Data)
        .then((data) => {
          this.Rows = data
        })
        .finally(() => {
          this.$store.state.renderComponentGrid = false
          this.$nextTick(() => {
            this.$store.state.renderComponentGrid = true
          })
        })
    },
    OnAgain(row) {
      this.$router.push({ name: 'DetailContract', params: { Status: 'Add', TblContract: row, TblCustomerId: row.TblCustomerId } })
    },
    OnDetailProduct(row) {
      this.$router.push({
        name: 'DetailContract',
        params: {
          Status: 'Product',
          TblContract: row,
          IsAccessDelete: this.$IsAccess('btnDeleteContract') && row.IsApproval == false,
          IsAccessSetDeposit: this.$IsAccess('btnSetDeposit'),
        },
      })
    },
  },
  mounted() {
    if(this.$store.state.FilterContractReminderReport){
      this.DataAxios=this.$store.state.FilterContractReminderReport
      this.Search();
    }
    this.$GetAccessUser()
  },
}
</script>
<style scoped></style>
